/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResumeTaskCommand } from '../../models/resume-task-command';
import { ResumeTaskCommandResult } from '../../models/resume-task-command-result';

export interface ApiTaskResumeTaskPut$Params {
      body?: ResumeTaskCommand
}

export function apiTaskResumeTaskPut(http: HttpClient, rootUrl: string, params?: ApiTaskResumeTaskPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ResumeTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskResumeTaskPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResumeTaskCommandResult>;
    })
  );
}

apiTaskResumeTaskPut.PATH = '/api/Task/ResumeTask';
